import tr from 'date-fns/locale/tr';
import enUS from 'date-fns/locale/en-US';

const getLocale = () => {
  const locale = window.navigator.language;

  return locale.includes('tr') ? tr : enUS;
};

export default getLocale;
